import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DYNAMIC_COMPONENT_DATA } from '@principle-theorem/ng-shared';
import { ROMEXIS_V2_INTEGRATION } from '@principle-theorem/principle-bridge-core';
import { Observable, of } from 'rxjs';
import { IIntegrationActionData } from '../../../../integration-action-data';
import { BridgeDeviceSelectorService } from '../../../bridge-device-selector-dialog/bridge-device-selector.service';
import { RomexisV2FeatureService } from '../romexis-v2-feature.service';

@Component({
  selector: 'pr-romexis-v2-open-patient',
  templateUrl: './romexis-v2-open-patient.component.html',
  styleUrl: './romexis-v2-open-patient.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RomexisV2OpenPatientComponent {
  isDisabled$: Observable<boolean>;

  constructor(
    @Inject(DYNAMIC_COMPONENT_DATA)
    private _data: IIntegrationActionData,
    private _romexisV2: RomexisV2FeatureService,
    private _bridgeDeviceSelector: BridgeDeviceSelectorService
  ) {
    this.isDisabled$ = of(false);
  }

  async openPatient(): Promise<void> {
    const device = await this._bridgeDeviceSelector.selectDevice(
      ROMEXIS_V2_INTEGRATION
    );
    if (!device) {
      return;
    }

    await this._romexisV2.openPatient(this._data.patient, device);
  }
}
